/* swissgz-part-search.js — Teilenummern-Suche robust gegen Trenner (Mercedes + SAP).

   Spiegelt swissgz.search.normalize.normalize_part_query: erkennt eine
   teilenummer-artige Sucheingabe (optional fuehrender Buchstabe, danach nur
   Ziffern + Trenner) und normalisiert sie:
   - Mit Buchstaben-Praefix (Mercedes): Trenner entfernen -> "A0179975547",
     der zusammenhaengende Token im Produkttitel.
   - Ohne Praefix, total 8 Ziffern (SAP-/Bexio-Artikelnummer): Punktform
     "2148.0036" — so steht die Nummer als SKU am Produkt. Der Punkt wird
     dabei NIE beim Tippen ins Feld eingefuegt (sonst wuerde das Weitertippen
     laengerer Nummern korrumpiert) — nur beim Absenden und in der
     Vorschau-Anfrage.
   - Ohne Praefix mit Punkt/Bindestrich (SAP "2148.059", ALN "787-0982"):
     unangetastet lassen — diese Formen matcht die native Suche direkt.

   Drei Einstiegspunkte:
   - input (Capture-Phase): kompaktiert Mercedes-Eingaben schon beim Tippen
     (Issue #34); die SAP-Punktform wird hier bewusst NICHT ins Feld geschrieben.
   - fetch-Wrapper: normalisiert den q-Parameter jeder /search/suggest-Anfrage
     (Predictive Search) und ergaenzt resources[options][fields] um
     variants.sku/variants.barcode, damit SAP-Nummern Treffer in der Vorschau
     liefern (die Standard-Felder der Vorschau durchsuchen keine SKU).
   - submit: volle Normalisierung als Sicherheitsnetz (inkl. SAP-Punktform).

   Reine Vanilla-JS, keine externen Abhaengigkeiten. Nicht teilenummer-artige
   Suchen (Woerter, Massangaben wie M10x1x32) bleiben unangetastet. */
(function () {
  "use strict";

  var PART_QUERY_RE = /^\s*([A-Za-z])?[\s.\-]*(\d[\d\s.\-]*\d)\s*$/;
  var SEPARATORS_RE = /[\s.\-]/g;

  function normalizePartQuery(value) {
    var m = PART_QUERY_RE.exec(value);
    if (!m) return value;
    var rest = m[2];
    var digits = rest.replace(SEPARATORS_RE, "");
    if (m[1]) return m[1].toUpperCase() + digits;
    if (digits.length === 8) return digits.slice(0, 4) + "." + digits.slice(4);
    if (rest.indexOf(".") !== -1 || rest.indexOf("-") !== -1) return rest;
    return digits;
  }

  function isSearchInput(el) {
    return !!el && el.tagName === "INPUT" && el.getAttribute("name") === "q";
  }

  function normalizeInput(input, allowSapDot) {
    if (!input) return;
    var normalized = normalizePartQuery(input.value);
    if (normalized === input.value) return;
    if (!allowSapDot && normalized.indexOf(".") !== -1 && input.value.indexOf(".") === -1) {
      return;
    }
    input.value = normalized;
    try {
      input.setSelectionRange(normalized.length, normalized.length);
    } catch (e) {}
  }

  document.addEventListener(
    "input",
    function (event) {
      if (isSearchInput(event.target)) normalizeInput(event.target, false);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== "function") return;
      if (!form.matches('form[action$="/search"]')) return;
      normalizeInput(form.querySelector('input[name="q"]'), true);
    },
    true
  );

  var FIELDS_KEY = "resources%5Boptions%5D%5Bfields%5D";
  var FIELDS_VALUE =
    "author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor";

  function patchSuggestUrl(url) {
    if (url.indexOf("/search/suggest") === -1) return url;
    var m = /([?&])q=([^&]*)/.exec(url);
    if (m) {
      var raw = null;
      try {
        raw = decodeURIComponent(m[2].replace(/\+/g, " "));
      } catch (e) {}
      if (raw !== null) {
        var normalized = normalizePartQuery(raw);
        if (normalized !== raw) {
          url =
            url.slice(0, m.index) +
            m[1] +
            "q=" +
            encodeURIComponent(normalized) +
            url.slice(m.index + m[0].length);
        }
      }
    }
    if (url.indexOf(FIELDS_KEY) === -1 && url.indexOf("resources[options][fields]") === -1) {
      url += (url.indexOf("?") === -1 ? "?" : "&") + FIELDS_KEY + "=" + FIELDS_VALUE;
    }
    return url;
  }

  if (typeof window.fetch === "function") {
    var originalFetch = window.fetch;
    window.fetch = function (resource, init) {
      try {
        if (typeof resource === "string") {
          resource = patchSuggestUrl(resource);
        } else if (typeof URL !== "undefined" && resource instanceof URL) {
          resource = patchSuggestUrl(resource.toString());
        }
      } catch (e) {}
      return originalFetch.call(this, resource, init);
    };
  }
})();
